import Link from 'next/link';
import { IMenuItem } from '~/src/api/content/menu';
import Promo from '~/src/components/Header/components/Promo';
import * as ST from './styled';

interface IProps {
    item: IMenuItem;
    isTarriff: boolean | undefined;
    onClick: (item: string) => void;
    clickHandler?: () => void;
}

const Card = ({ item, isTarriff, onClick, clickHandler }: IProps): JSX.Element => {
    return (
        <ST.CardWrapper>
            <ST.CardTitle
                isPromoted={!!item.promoted}
                withDesc={!!item.add_desc}
            >
                {item.title}
                {!!item.promoted && (
                    <ST.CardPromoIcon />
                )}
            </ST.CardTitle>
            {item.add_desc && (
                <ST.CardDescription
                    dangerouslySetInnerHTML={{ __html: item.add_desc }}
                />
            )}
            {isTarriff && (
                <Link href={item.link} prefetch={false}>
                    <ST.CardButton onClick={clickHandler}>
                        {item.button_text || 'Подключить'}
                    </ST.CardButton>
                </Link>
            )}
            {item.children?.map(childItem => (
                <ST.CardChildItem key={childItem.id} onClick={clickHandler}>
                    <Link href={childItem.link} passHref>
                        <ST.CardChildLink onClick={() => onClick(childItem.title)}>
                            {childItem.title}
                        </ST.CardChildLink>
                    </Link>
                </ST.CardChildItem>
            ))}
            {item.image && <Promo item={item} />}
        </ST.CardWrapper>
    );
};

export default Card;
